import { render } from "./mensajeregalos.vue?vue&type=template&id=fedb8338&scoped=true"
import script from "./mensajeregalos.vue?vue&type=script&lang=js"
export * from "./mensajeregalos.vue?vue&type=script&lang=js"

import "./mensajeregalos.vue?vue&type=style&index=0&id=fedb8338&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fedb8338"]])

export default __exports__